type createCookieProps = {
  name: string;
  value: string | string[];
};

const createCookie = ({ name, value }: createCookieProps) => {
  const date = new Date();
  date.setTime(date.getTime() + 300000);
  const expires = `;expires=${date}`;

  document.cookie = `${name}=${value}${expires};domain=.smiles.com.br;path=/`;
};

export { createCookie };
